var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-flex',[_c('v-row',{staticClass:"permissions-error-root-wrapper",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"permissions-error-item-wrapper"},[_vm._t("permissions-error-item")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }